import { ReduxDispatch } from "models/ReduxProps";
import ActionUtility from "utilities/ActionUtility";
import CercaPreventiviModel from "./models/CercaPreventiviModel";
import CercaSimulazioneFormModel from "./models/CercaSimulazioneFormModel";
import Cerca, { ISearchPreventiviRequest, ISearchSimulazioneRequest } from "./CercaEffects";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import CercaSimulazioneModel from "./models/CercaSimulazioneModel";
import CercaDettalgioSimulazioneModel from "./models/CercaDettalgioSimulazioneModel";
import CercaPreventiviFormModel from "./models/CercaPreventiviFormModel";
import CercaPreventiviTabellaModel from "./models/CercaPreventiviTabellaModel";
import CercaDettalgioPreventivoModel from "./models/CercaDettalgioPreventivoModel";

type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | CercaSimulazioneFormModel
    | CercaPreventiviFormModel
    | CercaDettalgioSimulazioneModel
    | CercaSimulazioneModel
    | CercaPreventiviModel
    | CercaDettalgioPreventivoModel
    | Blob;
export default class CercaAction {
    public static readonly REQUEST_CERCA_SIMULAZIONE_FORM: string = "CercaAction.REQUEST_CERCA_SIMULAZIONE_FORM";
    public static readonly REQUEST_CERCA_SIMULAZIONE_FORM_FINISHED: string =
        "CercaAction.REQUEST_CERCA_SIMULAZIONE_FORM_FINISHED";

    public static readonly REQUEST_ORDER_TABLE_BY: string = "CercaAction.REQUEST_ORDER_TABLE_BY";
    public static readonly REQUEST_ORDER_TABLE_BY_FINISHED: string = "CercaAction.REQUEST_ORDER_TABLE_BY_FINISHED";

    public static readonly REQUEST_CERCA_PREVENTIVI_FORM: string = "CercaAction.REQUEST_CERCA_PREVENTIVI_FORM";
    public static readonly REQUEST_CERCA_PREVENTIVI_FORM_FINISHED: string =
        "CercaAction.REQUEST_CERCA_PREVENTIVI_FORM_FINISHED";

    public static readonly REQUEST_CERCA_SIMULAZIONE_RESET: string = "CercaAction.REQUEST_CERCA_SIMULAZIONE_RESET";

    public static readonly REQUEST_CERCA_SIMULATION: string = "CercaAction.REQUEST_CERCA_SIMULATION";
    public static readonly REQUEST_CERCA_SIMULATION_FINISHED: string = "CercaAction.REQUEST_CERCA_SIMULATION_FINISHED";

    public static readonly REQUEST_FIND_SIMULATION: string = "CercaAction.REQUEST_FIND_SIMULATION";
    public static readonly REQUEST_FIND_SIMULATION_FINISHED: string = "CercaAction.REQUEST_FIND_SIMULATION_FINISHED";

    public static readonly REQUEST_FIND_SIMULATION_BY_ID: string = "CercaAction.REQUEST_FIND_SIMULATION_BY_ID";
    public static readonly REQUEST_FIND_SIMULATION_BY_ID_FINISHED: string =
        "CercaAction.REQUEST_FIND_SIMULATION_BY_ID_FINISHED";

    public static readonly REQUEST_SIMULATIONS_EXPORT_EXCEL: string = "CercaAction.REQUEST_SIMULATIONS_EXPORT_EXCEL";
    public static readonly REQUEST_SIMULATIONS_EXPORT_EXCEL_FINISHED: string =
        "CercaAction.REQUEST_SIMULATIONS_EXPORT_EXCEL_FINISHED";

    public static readonly REQUEST_CERCA_PREVENTIVI: string = "CercaAction.REQUEST_CERCA_PREVENTIVI";
    public static readonly REQUEST_CERCA_PREVENTIVI_FINISHED: string = "CercaAction.REQUEST_CERCA_PREVENTIVI_FINISHED";

    public static readonly REQUEST_CERCA_PREVENTIVI_RESET: string = "CercaAction.REQUEST_CERCA_PREVENTIVI_RESET";

    public static readonly REQUEST_PREVENTIVI_EXPORT_EXCEL: string = "CercaAction.REQUEST_PREVENTIVI_EXPORT_EXCEL";
    public static readonly REQUEST_PREVENTIVI_EXPORT_EXCEL_FINISHED: string =
        "CercaAction.REQUEST_PREVENTIVI_EXPORT_EXCEL_FINISHED";

    public static readonly REQUEST_DETTAGLIO_PREVENTIVO_BY_ID: string =
        "CercaAction.REQUEST_DETTAGLIO_PREVENTIVO_BY_ID";
    public static readonly REQUEST_DETTAGLIO_PREVENTIVO_BY_ID_FINISHED: string =
        "CercaAction.REQUEST_DETTAGLIO_PREVENTIVO_BY_ID_FINISHED";

    public static readonly REQUEST_FIND_PREVENTIVO_BY_ID: string = "CercaAction.REQUEST_FIND_PREVENTIVO_BY_ID";
    public static readonly REQUEST_FIND_PREVENTIVO_BY_ID_FINISHED: string =
        "CercaAction.REQUEST_FIND_PREVENTIVO_BY_ID_FINISHED";

    public static readonly REQUEST_FIND_PREVENTIVO_BY_ID_RESET: string =
        "CercaAction.REQUEST_FIND_PREVENTIVO_BY_ID_RESET";

    public static setCercaSimulazioneForm(form: CercaSimulazioneFormModel): any {
        return ActionUtility.createAction(CercaAction.REQUEST_CERCA_SIMULAZIONE_FORM_FINISHED, form);
    }

    public static setCercaPreventivoForm(form: CercaPreventiviFormModel): any {
        return ActionUtility.createAction(CercaAction.REQUEST_CERCA_PREVENTIVI_FORM_FINISHED, form);
    }

    public static resetCercaSimulazione(): any {
        return ActionUtility.createAction(CercaAction.REQUEST_CERCA_SIMULAZIONE_RESET);
    }

    public static searchSimulation(request: ISearchSimulazioneRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CercaSimulazioneModel>(
                dispatch,
                CercaAction.REQUEST_CERCA_SIMULATION,
                Cerca.cercaSimulazione,
                request
            );
        };
    }

    public static dettaglioSimulazioniGet(id: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CercaDettalgioSimulazioneModel>(
                dispatch,
                CercaAction.REQUEST_FIND_SIMULATION,
                Cerca.dettaglioSimulation,
                id
            );
        };
    }

    public static simulazioniExportExcel(
        request: ISearchSimulazioneRequest,
        progressHandler: (progress: number) => void
    ): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<any> => {
            return await ActionUtility.createThunkEffect<Blob>(
                dispatch,
                CercaAction.REQUEST_SIMULATIONS_EXPORT_EXCEL,
                Cerca.simulazioniExportExcel,
                request,
                progressHandler
            );
        };
    }

    public static serachSimulazioneById(id: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CercaDettalgioSimulazioneModel>(
                dispatch,
                CercaAction.REQUEST_FIND_SIMULATION_BY_ID,
                Cerca.dettaglioSimulation,
                id
            );
        };
    }

    public static searchEstimates(request: ISearchPreventiviRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CercaPreventiviModel>(
                dispatch,
                CercaAction.REQUEST_CERCA_PREVENTIVI,
                Cerca.cercaPreventivi,
                request
            );
        };
    }

    public static resetCercaPreventivi(): any {
        return ActionUtility.createAction(CercaAction.REQUEST_CERCA_PREVENTIVI_RESET);
    }

    public static preventiviExportExcel(
        request: ISearchPreventiviRequest,
        progressHandler: (progress: number) => void
    ): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<any> => {
            return await ActionUtility.createThunkEffect<Blob>(
                dispatch,
                CercaAction.REQUEST_PREVENTIVI_EXPORT_EXCEL,
                Cerca.preventiviExportExcel,
                request,
                progressHandler
            );
        };
    }

    public static GetDettagliPreventivi(item: CercaPreventiviTabellaModel): any {
        return ActionUtility.createAction(CercaAction.REQUEST_DETTAGLIO_PREVENTIVO_BY_ID_FINISHED, item);
    }

    public static dettaglioPreventivoGet(id: number, idRichiestaPrev: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<CercaDettalgioPreventivoModel>(
                dispatch,
                CercaAction.REQUEST_FIND_PREVENTIVO_BY_ID,
                Cerca.dettaglioPreventivo,
                id,
                idRichiestaPrev
            );
        };
    }

    public static resetDettaglioPreventivo(): any {
        return ActionUtility.createAction(CercaAction.REQUEST_FIND_PREVENTIVO_BY_ID_RESET);
    }
}
